function setupPowerBiMotion(root = document) {
  const sections = root.querySelectorAll('.topic-v2-powerbi .topic-v3-narrative > section');
  const showAll = () => sections.forEach(section => section.classList.add('is-visible'));
  if (!sections.length) return () => {};
  if (!('IntersectionObserver' in window) || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    showAll();
    return () => {};
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  sections.forEach(section => observer.observe(section));
  return () => observer.disconnect();
}

module.exports = setupPowerBiMotion;
